function scrollUp(value) {
  let position;

  if (value) {
    position = value
  } else {
    let distanceScrolled = window.pageYOffset;
    let filtersSection = document.getElementsByClassName('block-archive');
    let elemViewportOffset = filtersSection[0].getBoundingClientRect().top;
    position = distanceScrolled + elemViewportOffset;
  }

  window.scrollTo({
    top: position,
    left: 0,
    behavior: 'smooth'
  });
}

export default scrollUp;